import api from '@/api';
import {
  defineSyncSchema,
  schemaKinds,
  createSyncState,
  createSyncRequest,
  recordWrite,
  mergeSyncResponse,
  syncMutations,
} from '@/helpers/storeSync';

const PERMISO_SYNC_SCHEMA = defineSyncSchema({ key: 'ID_PERMISO', kind: 'permiso', insertAt: 'end' });

const state = {
  permisos: [],
  permisosTipos: [],
  sync: createSyncState(schemaKinds(PERMISO_SYNC_SCHEMA)),
};

const getters = {
  getPermisos: (state) => state.permisos,
  getPermisosTipos: (state) => state.permisosTipos,
  getPermisoById: (state) => (id) => state.permisos.find((p) => p.ID_PERMISO === id),
};

const mutations = {
  ...syncMutations,

  MERGE_PERMISOS(state, { rows, request }) {
    state.permisos = mergeSyncResponse(state.sync, state.permisos, rows, PERMISO_SYNC_SCHEMA, request);
  },

  SET_PERMISOS_TIPOS(state, permisosTipos) {
    state.permisosTipos = permisosTipos;
  },

  SOCKET_updatePermiso(state, permiso) {
    const index = state.permisos.findIndex((p) => p.ID_PERMISO === permiso.ID_PERMISO);
    if (index > -1) {
      state.permisos.splice(index, 1, permiso);
      recordWrite(state.sync, 'permiso', permiso.ID_PERMISO);
      this.notify('Permiso actualizado', `Se ha actualizado el permiso: ${permiso.NOMBRE}`, 'success');
    }
  },
};

const actions = {
  async fetchPermisos({ commit, state }) {
    try {
      commit('BEGIN_SYNC_REQUEST');
      const request = createSyncRequest(state.sync.seq);
      const response = await api.permiso.getPermisos();
      commit('MERGE_PERMISOS', { rows: response.data, request });
    } catch (err) {
      console.error('Error al obtener los permisos:', err);
      throw err;
    }
  },

  async fetchPermisosTipos({ commit }) {
    try {
      const response = await api.permiso.getPermisosTipos();
      const permisosTipos = response.data;
      commit('SET_PERMISOS_TIPOS', permisosTipos);
    } catch (err) {
      console.error('Error al obtener los permisos tipos:', err);
      throw err;
    }
  },

  async updatePermiso({ _commit }, payload) {
    try {
      await api.permiso.updatePermiso(payload);
    } catch (err) {
      console.error('Error al actualizar permiso:', err);
      throw err;
    }
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
